import appIconMintPrimaryDark from "@bednbody/ui/branding/brand/app-icon/mint-primary-dark.svg";
import appIconPrimaryDarkMint from "@bednbody/ui/branding/brand/app-icon/primary-dark-mint.svg";
import appIconPrimaryDarkWhite from "@bednbody/ui/branding/brand/app-icon/primary-dark-white.svg";
import appIconPrimaryWhite from "@bednbody/ui/branding/brand/app-icon/primary-white.svg";
import appIconTransparentWhite from "@bednbody/ui/branding/brand/app-icon/transparent-white.svg";
import appIconWhiteBlack from "@bednbody/ui/branding/brand/app-icon/white-black.svg";
import appIconWhitePrimary from "@bednbody/ui/branding/brand/app-icon/white-primary.svg";
import appIconWhitePrimaryDark from "@bednbody/ui/branding/brand/app-icon/white-primary-dark.svg";
import { cn } from "@bednbody/ui/lib/utils";

const sizeClasses = {
  sm: "h-8 w-8",
  md: "h-10 w-10",
  lg: "h-16 w-16",
} as const;

const variantSrc = {
  "primary-white": appIconPrimaryWhite,
  "primary-dark-white": appIconPrimaryDarkWhite,
  "white-primary": appIconWhitePrimary,
  "white-primary-dark": appIconWhitePrimaryDark,
  "white-black": appIconWhiteBlack,
  "primary-dark-mint": appIconPrimaryDarkMint,
  "mint-primary-dark": appIconMintPrimaryDark,
  "transparent-white": appIconTransparentWhite,
} as const;

export function AppIcon({
  size = "md",
  variant = "primary-white",
  className,
}: {
  size?: keyof typeof sizeClasses;
  variant?: keyof typeof variantSrc;
  className?: string;
}) {
  return (
    <img
      src={variantSrc[variant]}
      alt="Bednbody"
      draggable={false}
      className={cn("shrink-0 select-none object-contain", sizeClasses[size], className)}
    />
  );
}
